module.exports = __webpack_public_path__ + "static/digipadala-agent-e1a5fbc6f40876760f65566524234c90.png";